import { Alert, Col, Descriptions, Form, Input, Row, Typography } from 'antd';
import { useState } from 'react';
import { AjaxTable, CustomButton } from '../../components';
import {
  contractorsTable,
  contractsTable,
} from '../../api/module/ct_certifications';
import BreadcrumbContainer from '../../containers/Breadcrumb';
import { Link } from 'react-router-dom';
import INTERNAL_LINKS from '../../enums/InternalLinks';

const { Title, Text } = Typography;
const breadcrumbItems = [
  {
    text: 'Certificaciones',
  },
];

const CTCertificationsContracts = ({ resumeData, onBack, generalPerm }) => {
  const columns = [
    {
      title: 'Entidad contratante',
      dataIndex: 'organizacion_nombre',
    },
    {
      title: 'Proyecto',
      dataIndex: 'proyecto',
    },
    {
      title: 'No. Contrato',
      dataIndex: 'contrato_num',
      width: '6em',
    },
    {
      title: 'Cargo',
      dataIndex: 'rol',
      width: '20em',
    },
    {
      title: 'Acciones',
      key: 'acciones',
      width: '12em',
      render: (_, record) => (
        <Link to={`${INTERNAL_LINKS.CT_SPECIFIC_CERTIFICATIONS}/${record.pk}`}>
          <CustomButton
            text="Certificaciones"
            htmlType="button"
            block
            type="default"
          />
        </Link>
      ),
    },
  ];

  return (
    <>
      <Text>
        A continuación se muestra la lista de los contratos en los que ha
        participado
      </Text>
      <br />
      <br />
      <Descriptions
        layout="horizontal"
        column={2}
        bordered
        labelStyle={{ maxWidth: '5rem' }}
      >
        <Descriptions.Item label="Nombre completo / Razón social" span={2}>
          {resumeData.contratista_nombre}
        </Descriptions.Item>
        <Descriptions.Item label="Tipo de documento">
          {resumeData.tipo_identificacion_nombre}
        </Descriptions.Item>
        <Descriptions.Item label="Número de documento">
          {resumeData.identificacion}
        </Descriptions.Item>
      </Descriptions>
      <br />
      {generalPerm && (
        <Alert
          type="info"
          showIcon
          message="Información importante"
          description={
            <>
              <Text>
                Si desea generar una certificación donde se incluya más de un
                contrato de la misma entidad contratante, haga clic en el
                siguiente botón:
              </Text>
              <br />
              <Link
                to={`${INTERNAL_LINKS.CT_GENERAL_CERTIFICATIONS}/${resumeData.id}`}
              >
                <CustomButton htmlType="button" text="Certificación general" />
              </Link>
            </>
          }
        />
      )}
      <AjaxTable
        tableTitle="Listado de contratos"
        columns={columns}
        query={`filter[contrato__tercero]=${resumeData.id}`}
        endpoint={contractsTable}
        searchInput
        exportCSV
      />
      <CustomButton
        type="default"
        className="back-button"
        htmlType="button"
        text="Volver"
        onClick={onBack}
      />
    </>
  );
};

const CTCertifications = ({ generalPerm }) => {
  const [filters, setFilters] = useState();
  const [loading, setLoading] = useState(false);
  const [resumeData, setResumeData] = useState();
  const [form] = Form.useForm();

  function onFinish(data) {
    setFilters(data);
  }

  const columns = [
    {
      dataIndex: 'contratista_nombre',
      title: 'Nombres y Apellidos',
    },
    {
      dataIndex: 'tipo_identificacion_nombre',
      title: 'Sigla doc',
      align: 'center',
      width: '7em',
    },
    {
      dataIndex: 'identificacion',
      title: 'Nro. Documento',
      width: '14em',
    },
    {
      dataIndex: 'correo',
      title: 'Correo  electrónico',
    },
    {
      key: 'acciones',
      title: 'Acciones',
      width: '7em',
      render: (_, record) => (
        <CustomButton
          text="Ver"
          htmlType="button"
          block
          onClick={() => setResumeData(record)}
        />
      ),
    },
  ];

  return (
    <>
      <BreadcrumbContainer items={breadcrumbItems} />
      <Title className={'text-uppercase'} level={2}>
        CERTIFICACIONES
      </Title>
      {!resumeData ? (
        <>
          <Form form={form} layout="vertical" onFinish={onFinish}>
            <Title level={5}>Búsqueda por identificación</Title>
            <Row align="bottom" gutter={8}>
              <Col span={8}>
                <Form.Item label="Nombre" name="nombre">
                  <Input allowClear placeholder="Búsqueda por nombre" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="Número de documento" name="documento">
                  <Input
                    type="number"
                    allowClear
                    placeholder="Búsqueda por documento"
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="Correo electrónico" name="correo">
                  <Input allowClear placeholder="Correo electrónico" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={8} justify="start">
              <Col>
                <CustomButton loading={loading} text="Buscar" />
              </Col>
              <Col>
                <CustomButton
                  htmlType="button"
                  type="default"
                  onClick={() => {
                    form.resetFields();
                    setFilters();
                  }}
                  danger={true}
                  text="Borrar filtros"
                />
              </Col>
            </Row>
          </Form>
          {filters && (
            <AjaxTable
              tableTitle="Listado"
              columns={columns}
              query={filters}
              endpoint={contractorsTable}
              onLoading={setLoading}
            />
          )}
        </>
      ) : (
        <CTCertificationsContracts
          resumeData={resumeData}
          onBack={() => setResumeData()}
          generalPerm={generalPerm}
        />
      )}
    </>
  );
};

export default CTCertifications;
